"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.FeedbackBlockTitle = exports.FeedbackBlockBody = exports.FeedbackBlock = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _constants = require("../constants");
var _colors = require("../../birch/colors");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var flavorStyles = function flavorStyles(flavor, themeName) {
  var flavorMapping = themeName !== _constants.ReskinThemes.BIRCH ? flavorStyles.styles : flavorStyles.birchStyles;
  return flavorMapping[flavor] || {};
};
flavorStyles.birchStyles = {
  warning: {
    backgroundColor: _colors.FullPalette.YELLOW_E25
  },
  error: {
    backgroundColor: _colors.FullPalette.POPPY_E25
  },
  success: {
    backgroundColor: _colors.FullPalette.GREEN_E25
  },
  neutral: {
    backgroundColor: _colors.FullPalette.IRIS_E25
  }
};
flavorStyles.styles = {
  warning: {
    backgroundColor: _constants.colors.canaryYellow,
    borderColor: _constants.colors.darkYellow
  },
  error: {
    backgroundColor: _constants.colors.almostVeryLightRed,
    borderColor: _constants.colors.darkRed
  },
  success: {
    backgroundColor: _constants.colors.budgieGreen,
    borderColor: _constants.colors.mediumGreenhouseGreen
  },
  neutral: {
    backgroundColor: _constants.colors.babyBlue,
    borderColor: _constants.colors.darkBlue
  }
};
var sizeStyles = function sizeStyles(size) {
  return sizeStyles.styles[size] || {};
};
sizeStyles.styles = {
  small: {
    fontSize: '12px',
    padding: '10px 15px'
  },
  normal: {
    fontSize: '14px',
    padding: '14px 22px'
  }
};
var VALID_FLAVORS = Object.keys(flavorStyles.styles);
var VALID_SIZES = Object.keys(sizeStyles.styles);
var FeedbackBlock = _styledComponents["default"].div.withConfig({
  displayName: "feedback_block__FeedbackBlock"
})(["background-color:", ";padding:", ";font-size:", ";line-height:1.5;border-radius:", "px;", " margin-bottom:15px;position:relative;", ""], function (props) {
  var _props$theme;
  return flavorStyles(props.flavor, (_props$theme = props.theme) === null || _props$theme === void 0 ? void 0 : _props$theme.name).backgroundColor;
}, function (props) {
  return sizeStyles(props.size).padding;
}, function (props) {
  return sizeStyles(props.size).fontSize;
}, function (props) {
  var _props$theme2;
  return ((_props$theme2 = props.theme) === null || _props$theme2 === void 0 ? void 0 : _props$theme2.name) !== _constants.ReskinThemes.BIRCH ? "2" : "5";
}, function (props) {
  var _props$theme3, _props$theme4;
  return ((_props$theme3 = props.theme) === null || _props$theme3 === void 0 ? void 0 : _props$theme3.name) !== _constants.ReskinThemes.BIRCH && "border: solid 1px ".concat(flavorStyles(props.flavor, (_props$theme4 = props.theme) === null || _props$theme4 === void 0 ? void 0 : _props$theme4.name).borderColor, ";");
}, function (props) {
  return props.width ? (0, _styledComponents.css)(["width:", ";"], props.width) : '';
});
exports.FeedbackBlock = FeedbackBlock;
FeedbackBlock.displayName = 'FeedbackBlock';
FeedbackBlock.propTypes = {
  flavor: _propTypes["default"].oneOf(VALID_FLAVORS).isRequired,
  size: _propTypes["default"].oneOf(VALID_SIZES),
  width: _propTypes["default"].string
};
FeedbackBlock.defaultProps = {
  size: 'normal'
};
var FeedbackBlockTitle = _styledComponents["default"].div.withConfig({
  displayName: "feedback_block__FeedbackBlockTitle"
})(["font-size:14px;", ";"], (0, _constants.fontWeight)('normal'));
exports.FeedbackBlockTitle = FeedbackBlockTitle;
FeedbackBlockTitle.displayName = 'FeedbackBlockTitle';
var FeedbackBlockBody = _styledComponents["default"].div.withConfig({
  displayName: "feedback_block__FeedbackBlockBody"
})(["font-size:12px;color:", ";"], _constants.colors.darkGrey);
exports.FeedbackBlockBody = FeedbackBlockBody;
FeedbackBlockBody.displayName = 'FeedbackBlockBody';
var _default = FeedbackBlock;
exports["default"] = _default;